import { useState } from "react";
import { updateUserType } from "../../api/userService";

export const useUpdateUserType = (successCallback) => {
  const [updating, setUpdating] = useState(false);
  const update = async (id, data) => {
    setUpdating(true);
    try {
      const newRecord = await updateUserType(id, data);
      setUpdating(false);
      if (successCallback)
      {
        successCallback(newRecord);
      }
        return newRecord;
    } catch (error) {
      setUpdating(false);
      console.error("Failed to update user type:", error);
      throw error; // rethrow so the component can handle errors
    }
  };

  return { update, updating };
};